<template>
  <div class="login">
    <div class="title">欢迎使用万达商户平台</div>

    <van-form @submit="onSubmit" ref="form" class="form">
      <van-field :value="formatMobile" @input="handleInputMobile" maxlength="13" type="tel" name="phone" placeholder="请输入手机号码" />

      <van-field style="margin-top: 40px" :value="code" @input="handleInputCode" name="code" type="tel" maxlength="6"
        placeholder="请输入验证码">
        <template #button>
          <span style="color: #ff1d1d" @click="getCode" v-if="seconds == 0">获取验证码</span>
          <span style="color: #c6c6c6" v-else>重新获取({{ seconds }}s)</span>
        </template>
      </van-field>
      <div style="margin-top: 40px">
        <van-button color="linear-gradient(270deg, #FF8366 0%, #FF1D1D 100%)" round block :disabled="disabled" type="info"
          native-type="submit" :loading="loading">
          登录/注册
        </van-button>
      </div>
    </van-form>

    <div class="check">
      <van-checkbox v-model="checked" icon-size="12px" checked-color="#ee0a24">
        <div>已阅读并同意</div>
      </van-checkbox>
      <span class="a">
        <a :href="`${location.origin}${location.pathname}#/agreement?aType=user`">
          《用户协议》
        </a>
      </span>
      <span style="color: #999">和</span>
      <span>
        <a :href="`${location.origin}${location.pathname}#/agreement?aType=privacy`">
          《隐私政策》
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import { Button, Form, Field, Checkbox, Toast } from 'vant';
import { ApiGetVerify } from '@/api/insurance';
import { userInfoAuth } from './hooks';
const reg = /^(1[3-9][0-9])\d{8}$/
export default {
  components: {
    VanButton: Button,
    VanForm: Form,
    VanField: Field,
    VanCheckbox: Checkbox,
  },
  computed: {

  },
  data() {
    return {
      checked: false,
      mobile: '',
      formatMobile: '',
      code: '',
      loading: false,
      disabled: true,
      rules: {
        phone: [
          {
            required: true,
            trigger: 'onBlur',
          },
          {
            validator: (value) => {
              if (reg.test(value)) {
                return true;
              } else {
                return false;
              }
            },
            message: '手机号码格式错误',
            trigger: 'onBlur',
          },
        ],
      },
      seconds: 0,
      location: window.location,
    };
  },
  methods: {
    getCode() {
      // let reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // let reg = /^(1[3-9][0-9])\d{8}$/
      if (reg.test(this.mobile)) {
        ApiGetVerify(this.mobile);
        this.seconds = 60;
        setInterval(() => {
          this.seconds--;
          if (this.seconds <= 0) {
            this.seconds = 0;
          }
        }, 1000);
      } else {
        this.$toast('手机号码格式错误');
      }
    },
    async onSubmit() {
      if (!this.checked) return this.$toast('请阅读协议');
      this.loading = true
      userInfoAuth(this.mobile, this.code).finally(() => {
        this.loading = false
      })
    },
    handleInputMobile(value) {
      console.log(value);
      let phoneNum = value.split(' ').join('')

      this.mobile = phoneNum
      if (phoneNum.length > 11) {
        this.mobile = phoneNum.slice(11)
      } else if (phoneNum.length < 4) {
        this.formatMobile = phoneNum
          ? `${phoneNum.slice(0, 3)}`
          : '';

      } else if (phoneNum.length > 7) {
        this.formatMobile = phoneNum
          ? `${phoneNum.slice(0, 3)} ${phoneNum.slice(3, 7)} ${phoneNum.slice(7,11)}`
          : '';

      } else {
        this.formatMobile = phoneNum
          ? `${phoneNum.slice(0, 3)} ${phoneNum.slice(3, 7)}`
          : '';
      }



      if (reg.test(this.mobile) && this.code) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    handleInputCode(value) {
      this.code = value;
      if (reg.test(this.mobile) && this.code) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
  },
  mounted() {

  },
};
</script>

<style lang="less" scoped>
.login {
  padding: 0 40px;
}

.title {
  font-size: 21px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  line-height: 30px;
  margin-top: 48px;
  text-align: left;
}

.form {
  margin-top: 40px;

  /deep/.van-cell {
    padding-left: 0;
    padding-right: 0;
  }

  /deep/.van-cell::after {
    left: 0;
    right: 0;
  }

  /deep/.van-field__control {
    font-size: 16px;
    color: #111111;
    font-weight: 700;
  }

  /deep/.van-field__control::placeholder {
    font-weight: 300;
  }

  /deep/.van-button__text {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}

.check {
  margin-top: 12px;
  line-height: 1;
  font-size: 12px;
  font-weight: 400;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;

  span,
  a {
    color: #65b2f6;
  }

  /deep/.van-checkbox__label {
    margin-left: 4px;
    color: #999;
  }
}
</style>